import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useMaxCopayScheduleSteps = () => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]); /* Max Copay Schedule Steps Data */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();

  const [stateVal, setStateVal] = useState(location.state ?? []);
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSteps = [],
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.MAX_COPAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    type = "",
    paramsData: initialParamsData = {
      mcyMaxCopaySchedule: selectedSchedules[initialIndex]?.mcyMaxCopaySchedule,
      mcyMaxCopayDescription:
        selectedSchedules[initialIndex]?.mcyMaxCopayDescription,
      mczMaxCopayType: type,
      mczDaysSupply: selectedSchedules?.mczDaysSupply,
    },
    externalMode: initialExternalMode = false,
  } = currentState;

  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const [paramsData, setParamsData] = useState(initialParamsData);

  const {
    ADD_MAX_COPAY_SCHEDULE_STEPS,
    EDIT_MAX_COPAY_SCHEDULE_STEPS,
    DISPLAY_MAX_COPAY_SCHEDULE_STEPS,
  } = ROUTE_PATHS;

  const screen_title = "Max Copay Schedule Steps ";
  const screenNumber = "RCMCZ001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "MCY Max Copay Schedule",
      name: "mcyMaxCopaySchedule",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "MCY Max Copay Description",
      name: "mcyMaxCopayDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "CMM Copay Min/Max Type*ALL values",
      name: "mczMaxCopayType",
      label: "Type",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 1,
    },
    {
      fieldLabel: "MCZ Days Supply",
      name: "mczDaysSupply",
      label: "Days Supply",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 3,
    },
  ];

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        } else if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "CMM Copay Min/Max Type", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Max Copay Schedule Step",
      button_handeler: () => {
        navigateToPage(ROUTE_PATHS.ADD_MAX_COPAY_SCHEDULE_STEPS, [
          ...previousState,
          {
            ...currentState,
            paramsData: paramsData,
            currentIndex,
            externalMode,
          },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            selectedSchedules: [selectedSchedules[currentIndex]],
            selectedType: paramsData["mczMaxCopayType"],
            previousScreen: location.pathname,
            currentIndex: 0,
            mcyMaxCopayDescription: paramsData.mcyMaxCopayDescription,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        const selectedSchedulesCount = selectedRows.length;
        const { mczDaysSupply } = selectedSchedulesCount
          ? selectedRows[selectedSchedulesCount - 1]
          : rowData;
        navigateToPage(
          ROUTE_PATHS.EDIT_MAX_COPAY_SCHEDULE_STEPS,

          [
            ...previousState,
            {
              ...currentState,
              currentIndex,
              paramsData: { ...paramsData, mczDaysSupply: mczDaysSupply },
              externalMode,
            },
            {
              selectedSteps: selectedRows.length ? selectedRows : [rowData],
              selectedSchedules: selectedRows.length ? selectedRows : [rowData],
              selectedType: paramsData["mczMaxCopayType"],
              previousScreen: location.pathname,
              currentIndex: 0,
              mcyMaxCopayDescription: paramsData.mcyMaxCopayDescription,
            },
          ]
        );
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const selectedSchedulesCount = selectedRows.length;
        const { mczDaysSupply } = selectedSchedulesCount
          ? selectedRows[selectedSchedulesCount - 1]
          : rowData;
        navigateToPage(ROUTE_PATHS.DISPLAY_MAX_COPAY_SCHEDULE_STEPS, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            paramsData: { ...paramsData, mczDaysSupply: mczDaysSupply },
            externalMode,
          },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            selectedSchedules: selectedRows.length ? selectedRows : [rowData],
            selectedType: paramsData["mczMaxCopayType"],
            previousScreen: location.pathname,
            currentIndex: 0,
            mcyMaxCopayDescription: paramsData.mcyMaxCopayDescription,
          },
        ]);
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Days Supply",
      field: "mczDaysSupply",
    },
    {
      header: "Maximum Brand Amount",
      field: "mczMaxCopayBrand",
    },
    {
      header: "Maximum Generic Amount",
      field: "mczMaxCopayGeneric",
    },
    {
      header: "Look-back Days",
      field: "mczLookbackDays",
    },
    {
      header: "Look-back Start Date",
      field: "mczLookbackStartDate",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "mczDaysSupply";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/mczMaxCopaySteps`,
        null,
        {
          maxCopaySchedule:
            selectedSchedules[currentIndex]?.mcyMaxCopaySchedule,
          mcyMaxCopayDescription:
            selectedSchedules[currentIndex]?.mcyMaxCopayDescription,
          maxCopayType: paramsData.mczMaxCopayType,
          daysSupply: paramsData.mczDaysSupply,
          page: page,
          size: rows,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    currentIndex !== initialIndex &&
      setParamsData({
        mcyMaxCopaySchedule:
          selectedSchedules[currentIndex].mcyMaxCopaySchedule,
        mcyMaxCopayDescription:
          selectedSchedules[currentIndex].mcyMaxCopayDescription,
        mczMaxCopayType: type,
        mczDaysSupply: "",
      });
  }, [currentIndex]);

  useEffect(() => {
    if (selectedSchedules[currentIndex] && paramsData?.mczMaxCopayType)
      fetchData(); // Initial fetch with page 0 and page size 10
  }, [
    paramsData,
    rows,
    currentPage,
    currentIndex,
    selectedSchedules[currentIndex],
  ]);

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "set-params") {
        console.log("handleMessage", data);
        setStateVal(data);
        setExternalMode(true);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (
      externalMode &&
      initialParamsData?.mcyMaxCopaySchedule &&
      initialParamsData?.mcyMaxCopayDescription &&
      !paramsData?.mcyMaxCopaySchedule &&
      !paramsData?.mcyMaxCopayDescription
    ) {
      setParamsData(initialParamsData);
    }
  }, [externalMode, initialParamsData, paramsData]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      console.log(rowData);
      const params = {
        maxCopaySchedule: selectedSchedules[initialIndex].mcyMaxCopaySchedule,
        maxCopayType: type,
        daysSupply: rowData[parmKey],
      };
      axios_helper_no_header("DELETE", "api/mczMaxCopaySteps", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({
      maxCopaySchedule: selectedSchedules[initialIndex].mcyMaxCopaySchedule,
      maxCopayType: paramsData.mczMaxCopayType,
      daysSupply: "",
    });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/mczMaxCopaySteps/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
  };
};

export default useMaxCopayScheduleSteps;
